import { com } from '@eidu/web'
import entityApiUrl from '../entity/baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import SemanticLinkId = com.eidu.entity.analytics.SemanticLinkId

type DeleteSemanticLinkParameters = {
  semanticLinkId: SemanticLinkId
}

const deleteSemanticLink = async ({ semanticLinkId }: DeleteSemanticLinkParameters): Promise<void> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links/${semanticLinkId}`,
    {
      method: 'DELETE',
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return
      case 404:
        console.warn(`Got status ${response.status} from deleteSemanticLink endpoint`)
        throw Error(`Semantic link not found: ${semanticLinkId}`)
      default:
        throw Error(`Unexpected response code ${response.status} from deleteSemanticLink endpoint`)
    }
  })
}

export default deleteSemanticLink
